module.exports = __webpack_public_path__ + "static/img/celoscope-detail-31.c68c3c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-31.jpg
// module id = HOQz
// module chunks = 51